import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { resolveParticipantMembers } from '../../utils/tourDayLodgingUtils';
import { TourPartyMemberAvatar } from './TourPartyMemberAvatar';

/**
 * Compact row of profile avatars for people going to a tour stop.
 */
export function StopParticipantsRow({
  participantIds = [],
  members = [],
  theme,
  size = 22,
  maxVisible = 8,
  label = 'Going',
  style,
}) {
  const resolved = useMemo(
    () => resolveParticipantMembers(participantIds, members),
    [participantIds, members]
  );
  const styles = useMemo(() => createStyles(theme, size), [theme, size]);

  if (!resolved.length) return null;

  const visible = resolved.slice(0, maxVisible);
  const overflow = resolved.length - visible.length;

  return (
    <View style={[styles.row, style]}>
      <Text style={styles.label}>{label}</Text>
      <View style={styles.avatars}>
        {visible.map((member, index) => (
          <TourPartyMemberAvatar
            key={`${member.id || member.email || index}`}
            member={member}
            size={size}
            theme={theme}
            style={[styles.avatar, index > 0 && styles.avatarOverlap]}
          />
        ))}
        {overflow > 0 ? (
          <View style={[styles.overflowBadge, styles.avatarOverlap]}>
            <Text style={styles.overflowText}>+{overflow}</Text>
          </View>
        ) : null}
      </View>
    </View>
  );
}

function createStyles(theme, size) {
  return StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      flexWrap: 'wrap',
    },
    label: {
      fontSize: 10,
      fontWeight: '800',
      color: theme.text.tertiary,
      textTransform: 'uppercase',
      letterSpacing: 0.4,
    },
    avatars: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    avatar: {
      borderColor: theme.background.secondary,
    },
    avatarOverlap: {
      marginLeft: -6,
    },
    overflowBadge: {
      width: size,
      height: size,
      borderRadius: size / 2,
      backgroundColor: theme.background.elevated,
      borderWidth: 1.5,
      borderColor: theme.ui.border,
      alignItems: 'center',
      justifyContent: 'center',
    },
    overflowText: {
      fontSize: Math.max(9, size * 0.38),
      fontWeight: '800',
      color: theme.text.secondary,
    },
  });
}

export default StopParticipantsRow;
